module.exports = __webpack_public_path__ + "TB_Powerdown_SFX_A.wav.fb03fa77.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_down/TB_Powerdown_SFX_A.wav.mp3
// module id = 500
// module chunks = 0